import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import ShoppingCartContext from 'bundles/composable-page-header-consumer/contexts/ShoppingCartContext';
import { useNaptime } from 'bundles/naptimejs';
import CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import savedCartUtils from 'bundles/payments-common/lib/savedCartUtils';

const ShoppingCartProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const cartInfo = savedCartUtils.get();
  const cartId = location.query.cartId || (cartInfo && cartInfo.id);
  const { data, pending } = useNaptime<{ cart?: CartsV2 }>(
    () => ({
      cart: cartId && CartsV2.get(cartId),
    }),
    [cartId]
  );

  return (
    <ShoppingCartContext.Provider
      value={{
        cart: data?.cart,
        isValidCart: data?.cart && data.cart?.cartItems && data.cart.cartItems.length > 0,
        loading: pending,
      }}
    >
      {children}
    </ShoppingCartContext.Provider>
  );
};

export default ShoppingCartProvider;
